import { Box, Divider, TextButton } from '@wix/design-system';
import React__default, { useContext, useRef } from 'react';
import { RicosContext } from 'ricos-context';
import { useClickOutside } from '../../ClickOutside/useClickOutside.js';
import { ColorSwatches } from '../common/color-swatches.js';
import { FLOATING_COLOR_SWATCHES, RESET_BUTTON } from './data-hooks.js';
import { s as styleInject } from '../../style-inject.es-e7b07dd7.js';
import { useCustomColorPickerModal } from './floating-custom-color-picker/use-custom-color-picker-modal.js';
import { FloatingLayout } from '../../modal-layout/floating-layout/floating-layout.js';
import 'classnames';
import '../common/data-hooks.js';
import './floating-custom-color-picker/floating-custom-color-picker.js';
import '../../modal-layout/floating-layout/floating-desktop-layout.js';
import '../../ui-components-provider.js';
import '../../modal-layout/floating-layout/data-hooks.js';
import '../../modal-layout/fullscreen-mobile-layout/fullscreen-mobile-layout.js';
import '../../modal-layout/fullscreen-mobile-layout/data-hooks.js';

var css_248z = ".xmEjd{--wds-font-size-body-medium:16px}";
var classes = {"resetButton":"xmEjd"};
styleInject(css_248z);

const FloatingColorPicker = ({
  title,
  currentColor,
  userColors,
  onChange,
  onReset,
  closeModal,
  referenceElement,
  allowEmpty
}) => {
  const { t, isMobile } = useContext(RicosContext);
  const modalRef = useRef(null);
  const customColorPicker = useCustomColorPickerModal({
    onClickOutside: closeModal,
    componentProps: {
      title,
      color: currentColor == null ? void 0 : currentColor.toUpperCase(),
      onConfirm: (color) => {
        if (!userColors.includes(color)) {
          onChange({ type: "colorAdded", color });
        }
        customColorPicker.closeModal();
      },
      allowEmpty
    }
  });
  const onClickOutside = (e) => {
    var _a;
    const target = e.target;
    if (((_a = target == null ? void 0 : target.dataset) == null ? void 0 : _a.hook) === "tooltip-text" || (target == null ? void 0 : target.role) === "tooltip" || (referenceElement == null ? void 0 : referenceElement.contains(target))) {
      return;
    }
    closeModal();
  };
  useClickOutside(modalRef, onClickOutside, customColorPicker.isModalOpen());
  return /* @__PURE__ */ React__default.createElement(
    FloatingLayout,
    {
      onCloseButtonClick: closeModal,
      sidePanelProps: { height: "fit-content", width: isMobile ? "100%" : "240px" },
      dataHook: FLOATING_COLOR_SWATCHES,
      header: isMobile ? {
        title
      } : void 0,
      content: {
        noPadding: true,
        children: /* @__PURE__ */ React__default.createElement(Box, { ref: modalRef, direction: "vertical" }, /* @__PURE__ */ React__default.createElement(Box, { padding: isMobile ? "12px 24px" : "SP2", direction: "vertical" }, /* @__PURE__ */ React__default.createElement(
          ColorSwatches,
          {
            userColors,
            selectedColor: currentColor == null ? void 0 : currentColor.toUpperCase(),
            onAddClick: () => {
              customColorPicker.toggleModal(modalRef.current);
            },
            onChange: (color) => onChange({ type: "colorSelected", color }),
            size: isMobile ? "medium" : "small",
            allowEmpty
          }
        )), /* @__PURE__ */ React__default.createElement(Box, { paddingInline: "-24px", marginBlock: isMobile ? "12px" : void 0 }, /* @__PURE__ */ React__default.createElement(Divider, null)), /* @__PURE__ */ React__default.createElement(Box, { padding: isMobile ? "0px 24px 24px 24px" : "9px 12px" }, /* @__PURE__ */ React__default.createElement(
          TextButton,
          {
            onClick: () => {
              onReset();
              customColorPicker.closeModal();
            },
            underline: "always",
            size: isMobile ? "medium" : "tiny",
            className: classes.resetButton,
            dataHook: RESET_BUTTON
          },
          t("ColorPicker_SetToDefault_ButtonLabel")
        )))
      }
    }
  );
};

export { FloatingColorPicker };
//# sourceMappingURL=floating-color-picker.js.map
